var ACC = {
  config: {
    contextPath: document.getElementById('ph-content_path').value,
    encodedContextPath: document.getElementById('ph-encodedcontext_path').value,
    commonResourcePath: document.getElementById('ph-commonresource_path').value,
    themeResourcePath: document.getElementById('ph-themeresource_path').value,
    siteResourcePath: document.getElementById('ph-siteresource_path').value,
    language: document.getElementById('ph-langiagevar').value,
    rootPath: document.getElementById('ph-siteroute_url').value,
    CSRFToken: document.getElementById('ph-csrftoken').value
  },
  pwdStrengthVeryWeak: document.getElementById('ph-strengthveryweak').value,
  pwdStrengthWeak: document.getElementById('ph-strengthweak').value,
  pwdStrengthMedium: document.getElementById('ph-strengthmedium').value,
  pwdStrengthStrong: document.getElementById('ph-strengthstrong').value,
  pwdStrengthVeryStrong: document.getElementById('ph-strengthverystrong').value,
  pwdStrengthUnsafePwd: document.getElementById('ph-unsafepwd').value,
  pwdStrengthTooShortPwd: document.getElementById('ph-tooshortpwd').value,
  pwdStrengthMinCharText: document.getElementById('ph-minchartext').value,
  accessibilityLoading: document.getElementById('ph-arialoading').value,
  accessibilityStoresLoaded: document.getElementById('ph-storesloaded').value,
  ordersavedtext: document.getElementById('ph-ordersavedtext').value,
  withnametext: document.getElementById('ph-withnametext').value
};
